<div *ngIf="state === 'LOADING'" class="ajax_loading_wrapper">
  <div class="ajax_loading"></div>
</div>

<ng-container *ngIf="state === 'READY' || state === 'LOADING'">
  <h1>
    {{'Please confirm your e-mail address' | translate}}
  </h1>
  <p *ngIf="kind === 'registration'">
    {{'Click the button to confirm your registration. Only confirm if you have registered with mySolarlux yourself.' | translate}}
  </p>
  <p *ngIf="kind === 'email'">
    {{'Click the button to confirm your new e-mail address. Only confirm if you have changed your e-mail address at mySolarlux yourself.' | translate}}
  </p>
  <button type="button" class="btn btn-primary" [disabled]="state === 'LOADING'" (click)="confirm()">
    {{'Confirm e-mail address' | translate}}
  </button>
</ng-container>

<ng-container *ngIf="state === 'CONFIRMED'">
  <h1>
    {{'Wellcome to MySolarlux' | translate}}.
  </h1>
  <h1>
    {{'You have successfully confirmed your e-mail address' | translate}}.
  </h1>
  <button type="button" class="btn btn-primary" (click)="goToLogIn()">
    {{'log in' | translate}}
  </button>
</ng-container>

<ng-container *ngIf="state === 'ALREADY_CONFIRMED'">
  <h1>
    {{'Your e-mail address has already been confirmed. You can log in now.' | translate}}
  </h1>
  <button type="button" class="btn btn-primary" (click)="goToLogIn()">
    {{'log in' | translate}}
  </button>
</ng-container>

<ng-container *ngIf="state === 'EXPIRED'">
  <h1>
    {{'This link has expired. Please contact mySolarlux@solarlux.com to receive a new link.' | translate}}
  </h1>
</ng-container>

<ng-container *ngIf="state === 'INVALID'">
  <h1>
    {{'This link is invalid. If you need help, please contact mySolarlux@solarlux.com' | translate}}
  </h1>
</ng-container>

<ng-container *ngIf="state === 'ERROR'">
  <h1>
    {{'Your e-mail address could not be confirmed. Please try again later or contact mySolarlux@solarlux.com' | translate}}
  </h1>
</ng-container>
